import { EINREICHUNG_CONFIG } from '../configs/einreichung.config';
import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getNeweinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);

export const selectCurrentStep = createSelector(
  getNeweinreichungState,
  (state: EinreichungState) => state.assistant.currentStepIndex,
);

export const selectDataPrivacyAccepted = createSelector(
  getNeweinreichungState,
  (state: EinreichungState) => state.assistant.dataPrivacyAccepted,
);

export const selectIsCurrentStepLast = createSelector(
  getNeweinreichungState,
  (state: EinreichungState) => state.assistant.currentStepIndex === EINREICHUNG_CONFIG.assistantSteps.length - 1,
);
